














import Vue from 'vue'
export default Vue.extend({
  
  props: {
    pageTitle: {
      type: String,
      required: false
    },
    breadcrumbs: {
      type: Array,
      required: false
    },
    prevPagePath: {
      type: String,
      required: false
    },
    prevPageTitle: {
      type: String,
      required: false
    }
  }
  
})
